import numberRowStyles from './number-row';
